import { ClientThemeConfig, ClientName } from "./types";
import { cadentTheme } from "./clients/cadent";
import { demoTheme } from "./clients/demo";

const CLIENT_THEMES: Record<ClientName, ClientThemeConfig> = {
  cadent: cadentTheme,
  "broadham-green": demoTheme,
};

const rawClientName = import.meta.env.VITE_APP_BRAND ?? "cadent";
const clientName = rawClientName.toLowerCase() as ClientName;

export const clientTheme: ClientThemeConfig =
  CLIENT_THEMES[clientName] ?? CLIENT_THEMES.cadent;

export { clientName };
